import React from 'react';
import Link from 'gatsby-link';
import Markdown from 'react-markdown';
import Helmet from 'react-helmet';
import { Typography, Grid } from '@material-ui/core';
import styled from '../utils/styled';
import Section from '../components/Section';
import Button from '../components/Button';
import EventCard from '../components/EventCard';

const CardWrapperGrid = styled(Grid)(theme => ({
    container: true,
    spacing: 16,
    fontSize: '0.75em',
}));

const CardGrid = styled(Grid)(theme => ({
  textAlign: 'center',
}));

const overal = `
Me korraldame ka avalikke sündmuseid. Leiate meie sündmuste seast endale sobiliku seikluse. On võimalik osaleda nii individuaalselt kui ka kogu perega.
`;

const event1Json = {
    "dates": "19-20.02.2022",
    "name": "Pereseiklus - Suusa & laua nädalavahetus Võnnus (Cēsis, Läti)",
    "price": "al. 80€",
    "eventKey": "/ozolkalns"};

const eventSoomaaJson = {
    "dates": "16-17.04.2022",
    "name": "Isad ja pojad kanuumatk Soomaal 16-17 aprillil",
    "price": "al. 85€",
    "eventKey": "/soomaa"};

const Services = ({ data }) => {
  return (
    <Section>
      <Grid item xs={12} sm={8}>
        <Helmet title="Sündmused" />
        <Typography variant="display1">Sündmused</Typography>
        <Typography component={Markdown} source={overal} escapeHtml={false} />
      </Grid>
    </Section>
  );
};
export default Services;



// WEBPACK FOOTER //
// ./src/pages/events.js